module.exports = __webpack_public_path__ + "img/opera.600a5d9f.svg";